import { lazy, Suspense } from 'react'
import { UserRole } from '../enums'
import DashboardLayout from '../layouts/Dashboard'
import AuthGuard from '../components/guards/AuthGuard'
import LoadingState from '../components/LoadingState'
const HeatersPage = lazy(() => import('../pages/Heaters'))
const HeaterPage = lazy(() => import('../pages/Heater'))
const EditHeaterPage = lazy(() => import('../pages/EditHeater'))

export default [
  {
    path: '/heaters',
    element: (
      <AuthGuard roles={[UserRole.SUPERADMIN, UserRole.MANUFACTURER]}>
        <DashboardLayout>
          <Suspense fallback={<LoadingState />}>
            <HeatersPage />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    )
  },
  {
    path: '/heaters/:id',
    element: (
      <AuthGuard roles={[UserRole.SUPERADMIN, UserRole.MANUFACTURER]}>
        <DashboardLayout>
          <Suspense fallback={<LoadingState />}>
            <HeaterPage />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    )
  },
  {
    path: '/heaters/:id/edit',
    element: (
      <AuthGuard roles={[UserRole.SUPERADMIN, UserRole.MANUFACTURER]}>
        <DashboardLayout>
          <Suspense fallback={<LoadingState />}>
            <EditHeaterPage />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    )
  }
]
